import { AxiosError } from 'axios';
import { composeSentryContext } from '~/core/functions';
import { HttpStatusCode } from '~/core/enums';
export default defineNuxtPlugin(function () {
  var _useNuxtApp = useNuxtApp(),
    $sentry = _useNuxtApp.$sentry;
  var captureException = function captureException(error, tags, options) {
    if (error instanceof AxiosError) {
      var _error$response;
      if (options !== null && options !== void 0 && options.ignoreBadRequestError && ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === HttpStatusCode.BadRequest) {
        return '';
      }
    }
    return $sentry.captureException(error, composeSentryContext({
      error: error,
      tags: tags !== null && tags !== void 0 ? tags : {},
      level: options === null || options === void 0 ? void 0 : options.level
    }));
  };
  return {
    provide: {
      captureException: captureException
    }
  };
});